import React  from 'react'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { useDispatch } from "react-redux";
import { closeAccessCodeDialog } from '../state/accesscode/actions';
import { FormLabel } from '@mui/material';

const AccessCodeModal = ({
    open,
    value,
    setAccessCodeData,
    handleNewLoginUserName
}) => {
    const dispatch = useDispatch();
    // Function to set values of the Form Fields
    const changeHandler = (e) => {
        setAccessCodeData((prevState) =>
        ({...prevState, [e.target.name]: e.target.value }));
    };

     // Function to handle the close of Form popup
    const handleClose = (event, reason) => {
        setAccessCodeData({
            name : '',
            companyName : '',
            firstName:'',
        });
        dispatch(closeAccessCodeDialog());
    };

    return (
        <Dialog fullWidth maxWidth="sm" open={open}>
            <DialogTitle>Create Login</DialogTitle>
            <DialogContent dividers> 
                <FormLabel>Company Name </FormLabel><FormLabel sx={{color:'red'}}>*</FormLabel>
                <TextField  
                    name="companyName"
                    margin="dense"
                    fullWidth
                    value={value.companyName}
                    onChange={changeHandler}
                    //error={value.companyName === ""}
                    //helperText={value.companyName === "" ? "Required Field!" : " "}
                />
                <FormLabel>Name </FormLabel><FormLabel sx={{color:'red'}}>*</FormLabel>
                <TextField  
                    name="name"
                    margin="dense"
                    fullWidth
                    value={value.name}
                    onChange={changeHandler}
                    //error={value.name === ""}
                    //helperText={value.name === "" ? "Required Field!" : " "}
                />
                <FormLabel>First Name </FormLabel><FormLabel sx={{color:'red'}}>*</FormLabel>
                <TextField 
                    name="firstName"
                    margin="dense"
                    fullWidth
                    value={value.firstName}
                    onChange={changeHandler}
                    //error={value.firstName === ""}
                    //helperText={value.firstName === "" ? "Required Field!" : " "}
                />
            </DialogContent>
            <DialogActions>
                <Button  variant="contained"
                    size="medium"
                    color="primary" 
                    onClick={handleNewLoginUserName}
                >Submit</Button>
                <Button  variant="contained"
                    size="medium"
                    color="error" onClick={handleClose}>Cancel</Button>
            </DialogActions>
        </Dialog>
    )
}

export default AccessCodeModal
